module.exports = __webpack_public_path__ + "static/media/02(6).cc0bb6a8.jpg";